export default __webpack_public_path__ + "static/media/640_business06-en-web.791ebeba.png";